import { FC, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  PlusSubscriptionModalButton,
  PlusSubscriptionModalButtonProps,
} from 'src/components/plusSubscription/modals/components/Button';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { PlusSubscriptionLearnMore } from 'src/components/plusSubscription/LearnMore';
import { anyRequestStart } from 'src/store/anyRequest/slice';
import { apiContinueWithBasicSubscription } from 'src/api/plusSubscriptionPlanSelection';
import { useAnyRequest } from 'src/utils/hooks/useAnyRequest';
import { hardRedirect } from 'src/utils/hardRedirect';
import { useTHelper } from 'src/utils/i18n';
import { useBemHelper } from 'src/utils/hooks/useBemHelper';
import { deCommonCurrentPartnerSelector } from '../../../../store/commonPart/selector';

type Props = Omit<PlusSubscriptionModalButtonProps, 'onClick'> & {
  partnerName: string;
};

export const PlusSubscriptionModalSwitchButton: FC<Props> = ({ partnerName, ...props }) => {
  const tHelper = useTHelper('plusSubscription.modals.confirmSwitch');

  const bemHelper = useBemHelper('plus-subscription-modal-confirm-switch');
  const { CampaignTerminologySingular, CampaignTerminologyPlural } = useSelector(deCommonCurrentPartnerSelector);

  const [isShowModal, setIsShowModal] = useState(false);
  const showModal = useCallback(() => setIsShowModal(true), []);
  const closeModal = useCallback(() => setIsShowModal(false), []);

  const dispatch = useDispatch();

  const uniqueId = 'continueWithRallyUpNow';

  const handleSuccess = useCallback(() => {
    dispatch(
      anyRequestStart({
        data: null,
        apiFunction: apiContinueWithBasicSubscription,
        uniqueId,
      })
    );
  }, [dispatch]);

  const response = useAnyRequest(uniqueId, {
    onSuccess: () => hardRedirect('/'),
  });

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <PlusSubscriptionModalButton {...props} onClick={showModal} />

      {isShowModal && (
        <UiModal
          modalClassName={bemHelper()}
          onHide={closeModal}
          header={tHelper('header', { partner: partnerName })}
          successBtnText={tHelper('successButton', { partner: partnerName })}
          successBtnOnClick={handleSuccess}
          successLoading={response.loading}
        >
          <div className={bemHelper('text')}>
            {tHelper('text', {
              partner: partnerName,
              campaignPluralTerminology: CampaignTerminologyPlural,
              campaignSingularTerminology: CampaignTerminologySingular,
            })}
          </div>
          <PlusSubscriptionLearnMore className={bemHelper('learn-more')} />
        </UiModal>
      )}
    </>
  );
};
